import { FormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterAgeRangeType } from './covance-filter-age-range-type';
import { FilterAgeRangeValue } from '../covance-filter.models';
import { combineLatest, Subscription, Subject } from 'rxjs'; 
import { debounceTime, map, skip } from 'rxjs/operators';
import { Event } from '@angular/router';

@Component({
    selector: 'covance-filter-age-range-type',
    template: require('./covance-filter-age-range-type.component.html'),
    styles: [require('./covance-filter-age-range-type.component.scss')],
})
export class CovanceFilterAgeRangeTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterAgeRangeType> implements OnDestroy, OnInit {

    @Input()
    public filterSelectionNotification: Subject<any>;

    public startUnit = new FormControl();
    public endUnit = new FormControl();
    public startValue = new FormControl();
    public endValue = new FormControl();
    private isRefreshed = false;
    private subscription: Subscription;
    private filterChanged = false;

    constructor(filterAgeRangeType: CovanceFilterAgeRangeType) {
        super(filterAgeRangeType);
    }

    public ngOnInit() {

        this.subscription = combineLatest([
            this.startUnit.valueChanges,
            this.endUnit.valueChanges,
            this.startValue.valueChanges,
            this.endValue.valueChanges])
            .pipe(
                skip(1),
                debounceTime(1000),
                map(([startUnit, endUnit, startValue, endValue]) => {
                    return [(startUnit || this.ageUnits[0]), (endUnit || this.ageUnits[0]), startValue, endValue];
                })
        ).subscribe(([startUnit, endUnit, startValue, endValue]) => {
                this.fieldVal.value = new FilterAgeRangeValue(startValue, startUnit, endValue, endUnit);
                this.filterType.setQueryParamValue(this.fieldVal);
                this.filterType.onFieldChange(this.fieldVal);

                this.startUnit.setValue(startValue ? this.fieldVal.value && this.fieldVal.value.ageUnitStart : null, {emitEvent: false});
                this.endUnit.setValue(endValue ? this.fieldVal.value && this.fieldVal.value.ageUnitEnd : null, { emitEvent: false });

                this.isRefreshed = true;
            });

        this.filterSelectionNotification.subscribe(event => {
            this.filterChanged = event;
        });

        this.setInitialValues();
    }

    public ngDoCheck() {
        if (!this.fieldVal.value && this.isRefreshed) {
                this.setInitialValues();
                this.isRefreshed = false;
        }
        if (this.filterChanged) {
            this.setInitialValues();
            this.isRefreshed = false;
            this.filterChanged = false;
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
        this.filterSelectionNotification.unsubscribe();
    }

    public isInvalidAgeRange() {
        if (this.fieldVal.value) {
            return !this.fieldVal.value.isValid;
        } else {
            return true;
        }
    }

    public get ageUnits() {
        return ['years', 'days', 'months'];
    }

    private setInitialValues() {
        this.startUnit.setValue(this.fieldVal.value && this.fieldVal.value.ageUnitStart);
        this.endUnit.setValue(this.fieldVal.value && this.fieldVal.value.ageUnitEnd);
        this.startValue.setValue(this.fieldVal.value && this.fieldVal.value.ageValueStart);
        this.endValue.setValue(this.fieldVal.value && this.fieldVal.value.ageValueEnd);
    }
}